import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Icon, Typography } from 'ck-ui';
import styles from './HoverableIconBtn.module.scss';

const HoverableIconBtn = ({ className, iconName, iconColor, onClick, text, ...rest }) => (
  <button
    aria-label={text}
    type="button"
    className={classnames(className, styles.root)}
    onClick={() => onClick && onClick()}
    {...rest}
  >
    <Icon
      name={iconName}
      color={iconColor}
    />
    <Typography variant="body-small" color="black-bis" className={styles.text}>{text}</Typography>
  </button>
);

HoverableIconBtn.propTypes = {
  className: PropTypes.string,
  iconName: PropTypes.string.isRequired,
  iconColor: PropTypes.string,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

HoverableIconBtn.defaultProps = {
  className: null,
  onClick: null,
  iconColor: 'primary'
};

export { HoverableIconBtn };
